/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EServicePlaceRequest = 'AtRepairshop' | 'AtCustomerSite' | 'AllServicePlace';

export const EServicePlaceRequest = {
    AtRepairshop: 'AtRepairshop' as EServicePlaceRequest,
    AtCustomerSite: 'AtCustomerSite' as EServicePlaceRequest,
    AllServicePlace: 'AllServicePlace' as EServicePlaceRequest
};

